import { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { trackWhatsAppClick } from '../lib/analytics';

export const WhatsAppButton = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { t } = useLanguage();

  const handleClick = () => {
    trackWhatsAppClick();
    window.open(`https://wa.me/491631945793?text=${encodeURIComponent(t.whatsapp.message)}`, '_blank');
  };

  return (
    <div className="fixed bottom-8 right-8 z-50" data-testid="whatsapp-button">
      {isExpanded && (
        <div className="absolute bottom-20 right-0 bg-white rounded-2xl shadow-2xl p-6 w-72 animate-fade-in">
          <button onClick={() => setIsExpanded(false)} className="absolute top-3 right-3 text-gray-400 hover:text-gray-600">
            <X className="w-5 h-5" />
          </button>
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 bg-[#25d366] rounded-full flex items-center justify-center">
              <MessageCircle className="w-5 h-5 text-white" />
            </div>
            <div>
              <p className="font-bold text-gray-800 text-sm">Panthera Umzug</p>
              <p className="text-xs text-[#25d366]">Online</p>
            </div>
          </div>
          <p className="text-gray-600 text-sm mb-3">{t.whatsapp.message}</p>
          <button onClick={handleClick} className="w-full bg-[#25d366] hover:bg-[#20ba5a] text-white font-bold py-2.5 rounded-lg text-sm transition-colors">
            {t.whatsapp.chat}
          </button>
        </div>
      )}
      <button
        onClick={handleClick}
        onMouseEnter={() => setIsExpanded(true)}
        className="bg-[#25d366] hover:bg-[#20ba5a] text-white p-4 rounded-full shadow-2xl transition-all duration-300 hover:scale-110 relative"
        aria-label="WhatsApp"
      >
        <MessageCircle className="w-7 h-7" />
        <span className="absolute -top-1 -right-1 flex h-5 w-5">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#D4AF37] opacity-75"></span>
          <span className="relative inline-flex rounded-full h-5 w-5 bg-[#D4AF37] items-center justify-center text-black text-[10px] font-bold">1</span>
        </span>
      </button>
    </div>
  );
};
